const LangForgotPassword = {
  "forgotPassword._title": ["Forgot Password", "QUÊN MẬT KHẨU"],
  "forgotPassword.form.button._resetMyPassword": [
    "Reset Password",
    "Thay đổi mật khẩu"
  ],
  "forgotPassword._description": [
    `Enter the mobile number used to sign up for your account. We will send you an email with information on how to reset your password.`,
    `Chúng tôi sẽ gửi thông tin hướng dẫn bạn cách chọn lại mật khẩu.`
  ]
};

export default LangForgotPassword;



// WEBPACK FOOTER //
// ./src/resources/pages/LangForgotPassword.js